import { useState, useEffect } from 'react'
import { useDashboardStore } from '../store/dashboardStore'
import { getStats } from '../services/api'

export function useProfitData() {
  const period = useDashboardStore(s => s.period)
  const [data, setData] = useState({ today: 0, yesterday: 0, difference: 0 })

  useEffect(() => {
    let cancelled = false

    // Загрузка «Сегодня/Вчера» из /api/stats. Карточки обновляются
    // автоматически каждые 15 сек — новые сделки (и демо, и реальные)
    // появляются на «Главной» без перезагрузки страницы.
    const load = () => getStats(period)
      .then(stats => {
        if (cancelled) return
        setData({
          today:      stats.todayProfit     ?? 0,
          yesterday:  stats.yesterdayProfit ?? 0,
          difference: (stats.todayProfit ?? 0) - (stats.yesterdayProfit ?? 0),
        })
      })
      .catch(() => {})

    load()
    const id = setInterval(load, 15000)
    return () => { cancelled = true; clearInterval(id) }
  }, [period])

  return { ...data, period }
}
